import React from 'react';

const SkeletonLine = ({ className = '' }) => (
    <div className={`clinic-settings-skeleton__line ${className}`.trim()} />
);

function ClinicSettingsListSkeleton({ rows = 5 }) {
    return (
        <div className="clinic-settings-skeleton">
            {Array.from({ length: rows }).map((_, index) => (
                <div key={`clinic-settings-skeleton-${index}`} className="clinic-settings-skeleton__row card">
                    <SkeletonLine className="clinic-settings-skeleton__line--medium" />
                    <SkeletonLine className="clinic-settings-skeleton__line--long" />
                    <SkeletonLine className="clinic-settings-skeleton__line--short" />
                </div>
            ))}
        </div>
    );
}

export default ClinicSettingsListSkeleton;
